export function hasDatePassed(date) {
  const targetDate = new Date(date);
  const todayDate = new Date();
  const targetDateOnly = new Date(
    targetDate.getUTCFullYear(),
    targetDate.getUTCMonth(),
    targetDate.getUTCDate()
  );
  const todayOnly = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    todayDate.getDate()
  );

  return targetDateOnly < todayOnly;  // Only disable if expiry date is before today
}
